import { useFetch } from '@reveni-io/reveni-ui'

import services from '@/services/services'

import { transformRequestServicePoints, transformResponseServicePoints } from './transformers'

const useServicePoints = ({ orderId, returnId, deliveryMethodId, city }) => {
  const {
    data,
    setData,
    fetchData: requestServicePoints,
    loading: searchingServicePoints,
  } = useFetch(services.getServicePoints, {
    doInitialRequest: false,
    transformRequest: transformRequestServicePoints,
    transformResponse: transformResponseServicePoints,
  })

  const searchServicePoints = async address => {
    try {
      await requestServicePoints({ orderId, returnId, deliveryMethodId, address, city })
    } catch {
      setData([])
    }
  }

  return { servicePoints: data || [], searchServicePoints, searchingServicePoints }
}

export default useServicePoints
